// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"MapPOIS_wrapper__2vFN8","map_title_style":"MapPOIS_map_title_style__1NnEA"};